<template>
  <svg
    width="117"
    height="90"
    viewBox="0 0 117 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-curved-arrow-down"
  >
    <path
      d="M3.64645 89.3536C3.84171 89.5488 4.15829 89.5488 4.35355 89.3536L7.53553 86.1716C7.7308 85.9763 7.7308 85.6597 7.53553 85.4645C7.34027 85.2692 7.02369 85.2692 6.82843 85.4645L4 88.2929L1.17157 85.4645C0.976311 85.2692 0.659728 85.2692 0.464466 85.4645C0.269204 85.6597 0.269204 85.9763 0.464466 86.1716L3.64645 89.3536ZM4.5 89C4.5 55.0993 14.8272 33.2793 33.9632 19.9026C53.141 6.4967 81.2595 1.50006 117 1.5V0.5C81.2118 0.500064 52.8304 5.49376 33.3903 19.083C13.9085 32.7014 3.5 54.8814 3.5 89H4.5Z"
      fill="#A76921"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.icon-curved-arrow-down {
  display: block;
}
</style>
